import React, {useEffect, useState} from 'react';
import {Alert, Button, Container, Spinner} from 'react-bootstrap';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import * as api from '../api';
import {
  isSafeMobileSsoDestination,
  markMobilePhysicalTopup,
  MOBILE_PHYSICAL_TOPUP_FLOW,
  MOBILE_PHYSICAL_TOPUP_PATH
} from '../util/mobile-physical-topup';


const MobileLogin = ({location, history}) => {
  const {t} = useTranslation();
  const [failed, setFailed] = useState(false);
  const requestedRedirect = new URLSearchParams(location.search || '').get('redirect');
  const requestedFlow = requestedRedirect === MOBILE_PHYSICAL_TOPUP_PATH ? MOBILE_PHYSICAL_TOPUP_FLOW : null;
  const fallbackPath = isSafeMobileSsoDestination(requestedRedirect, requestedFlow) ? requestedRedirect : '/';

  useEffect(() => {
    let active = true;
    const parameters = new URLSearchParams(location.search || '');
    const code = parameters.get('code');

    // Remove the one-time code from browser history before making network calls.
    window.history.replaceState({}, document.title, '/mobile-login');
    if (!code) {
      setFailed(true);
      return () => { active = false; };
    }

    api.consumeMobileSsoToken(code).then(result => {
      if (!active) return;
      const redirectPath = result.json && result.json.redirectPath;
      const flow = result.json && result.json.flow;
      if (result.status !== 200 || !result.json.token || !isSafeMobileSsoDestination(redirectPath, flow)) {
        setFailed(true);
        return;
      }

      if (redirectPath === MOBILE_PHYSICAL_TOPUP_PATH) {
        markMobilePhysicalTopup();
      }

      const cookies = new Cookies();
      cookies.set('replayerAuth', {token: result.json.token, email: result.json.email}, {
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:'
      });
      window.location.replace(redirectPath);
    });

    return () => { active = false; };
  }, [location.search]);

  if (failed) {
    const loginPath = `/login?next=${encodeURIComponent(fallbackPath)}&mobileSsoError=1`;
    return (
      <Container style={{maxWidth: 640, paddingTop: 120, paddingBottom: 120}}>
        <Alert variant="warning">
          {t('LOGIN_MOBILE_SSO_EXPIRED')}
        </Alert>
        <Button onClick={() => history.replace(loginPath)}>{t('LOGIN_GO_TO_LOGIN')}</Button>
      </Container>
    );
  }

  return (
    <Container className="text-center" style={{paddingTop: 160, paddingBottom: 160}}>
      <Spinner animation="border" role="status"/>
      <p className="mt-3">{t('LOGIN_SECURE_ACCESS_IN_PROGRESS')}</p>
    </Container>
  );
};

MobileLogin.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default MobileLogin;
